<template>
    <span>
        <h3 v-if="count > 0">Ostukorv</h3>
        <h3 v-else>Teie ostukorv on tühi</h3>

        <table class="table table-sm table-hover" v-if="count > 0">
            <thead>
                <tr>
                    <th colspan="4"></th>
                    <th v-for="source in sources" v-bind:key="source" class="text-right">
                        <small class="font-weight-bold">{{source}}</small>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in cart" v-bind:key="item.item.id">
                    <td>
                        {{item.item.manufacturer}} {{item.item.code}}<br>
                        <small>{{item.item.name}}</small>
                    </td>
                    <td>
                        <a href="#" title="Kustuta" @click.prevent.stop="removeItem(item.item.id)">
                            <b-icon-trash></b-icon-trash>
                        </a>
                    </td>
                    <td>
                        <a href="#" @click.prevent.stop="decQty(item.item.id)" title="Vähenda">
                            <b-icon-dash-square></b-icon-dash-square>
                        </a>
                        &nbsp;
                        <a href="#" @click.prevent.stop="incQty(item.item.id)" title="Lisa">
                            <b-icon-plus-square></b-icon-plus-square>
                        </a>
                    </td>
                    <td></td>
                    <td v-for="source in sources" v-bind:key="source" class="text-right">
                        <span v-if="matrix[item.item.id][source]" :style="cheapestMap[item.item.id] == source ? 'background-color:#BBFFB5' : ''" class="p-1">
                            <small style="color: lightgray">{{item.qty}}× </small>
                            <a :href="matrix[item.item.id][source].link" target="_blank">{{matrix[item.item.id][source].price | twoDecimals }}</a>  €
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="font-weight-bold" colspan="4">Kokku:</td>
                    <td v-for="source in sources" v-bind:key="source" class="text-right" :style="cheapestCart == source ? 'background-color:#BBFFB5' : ''">
                        <span class="font-weight-bold">{{total[source] | twoDecimals }} €</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <button type="button" class="btn btn-danger" @click="emptyCart" v-if="count > 0">Tühjenda ostukorv</button>
    </span>
</template>

<script>

    import { BIconTrash, BIconPlusSquare, BIconDashSquare } from 'bootstrap-vue'

    export default {
        name: "Cart",
        components: {
            'b-icon-trash': BIconTrash,
            'b-icon-plus-square': BIconPlusSquare,
            'b-icon-dash-square': BIconDashSquare
        },
        mounted: function(){
            this.$store.dispatch('cart/fromStorage');
        },
        methods: {
            removeItem: function(id){
                this.$store.dispatch('cart/removeCartItem', id);
            },
            incQty: function(id){
                this.$store.dispatch('cart/incCartItem', id);
            },
            decQty: function(id){
                this.$store.dispatch('cart/decCartItem', id);
            },
            emptyCart: function(){
                this.$store.dispatch('cart/emptyCart');
            },
        },
        computed: {
            count: function(){
                return this.$store.getters['cart/getCount'];
            },
            cart: function(){
                return this.$store.getters['cart/getCart'];
            },
            sources: function(){
                return this.$store.getters['cart/getSources']
            },
            matrix: function(){
                return this.$store.getters['cart/getMatrix']
            },
            total: function(){
                return this.$store.getters['cart/getTotal'];
            },
            cheapestMap: function(){
                return this.$store.getters['cart/getCheapestMap'];
            },
            cheapestCart: function(){
                let price = 99999999.99;
                let source = false;
                let total = this.$store.getters['cart/getTotal'];
                for (let src in total) {
                    if (total[src] < price) {
                        price = total[src];
                        source = src;
                    }
                }
                return source;
            },
        },
    }

</script>

<style scoped>
</style>